import { render, staticRenderFns } from "./how-to-use.vue?vue&type=template&id=30102978&scoped=true"
import script from "./how-to-use.vue?vue&type=script&lang=ts"
export * from "./how-to-use.vue?vue&type=script&lang=ts"
import style0 from "./how-to-use.vue?vue&type=style&index=0&id=30102978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30102978",
  null
  
)

export default component.exports